<ion-content>
    <ion-grid>
        <ion-row style="margin-top: 35px;">
            <ion-col text-center>
                <span class="weight-medium">DAUER</span>
            </ion-col>
        </ion-row>
        <ion-row class="bottom-line">
            <ion-col text-center>
                <strong class="font-size-verylarge">
                    {{ scope.getCurrentDuration()}}
                </strong>
            </ion-col>
        </ion-row>
        <ion-row margin-top class="bottom-line">
            <ion-col text-center>
                <span class="weight-medium"> {{ 'CONFIGURATOR_DISPLAY_DISTANCE' | translate | uppercase }}</span>
                <br>
                <strong class="font-size-extralarge">{{ scope.getDeepDistance() }}</strong>
                <br>
                <span class="weight-medium">KM</span>
            </ion-col>
        </ion-row>
        <ion-row margin-top class="bottom-line">
            <ion-col text-center col-6>
                <span class="weight-medium">{{ 'CONFIGURATOR_DISPLAY_SPEED' | translate | uppercase }} </span>
                <br>
                <strong class="font-size-medium">{{ scope.getCurrentSpeed() | date:'m:ss' }}</strong>
                <br>
                <span class="weight-medium">MIN/KM</span>
            </ion-col>
            <ion-col text-center col-6>
                <span class="weight-medium">{{ 'CONFIGURATOR_DISPLAY_SPEED' | translate | uppercase }}</span>
                <br>
                <strong class="font-size-medium">{{ scope.getAverageSpeed() }}</strong>
                <br>
                <span class="weight-medium">KM/H</span>
            </ion-col>
        </ion-row>
        <ion-row margin-top>
            <ion-col text-center>
                <span class="weight-medium">{{ 'CONFIGURATOR_DISPLAY_STEPS' | translate | uppercase }}</span>
                <br>
                <strong class="font-size-medium">{{ scope.steps }}</strong>
            </ion-col>
        </ion-row>

        <ion-row class="bottom-bar">
            <ion-col class="centered">
                <button ion-button icon-only clear (click)="onDismiss()">
                    <ion-icon name="ios-map-outline"></ion-icon>
                </button>
            </ion-col>
            <ion-col text-center>
                <button *ngIf="!scope.getStarted()" ion-button class="round scale-big colored round-big" icon-only clear
                    (click)="scope.startTrack()">
                    <ion-icon name="play" class="font-medium"></ion-icon>
                </button>
                <button *ngIf="scope.getStarted()" ion-button class="round scale-big colored round-big" icon-only clear
                    (click)="scope.stopTrack()">
                    <ion-icon name="pause-outline" class="font-medium"></ion-icon>
                </button>
            </ion-col>
            <ion-col text-center class="centered">
                <button ion-button icon-only clear (click)="scope.restartTrack()">
                    <ion-icon name="radio-button-off">
                    </ion-icon>
                </button>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>